import{jsx as r}from"react/jsx-runtime";import t from"../../../Typography/Typography.js";var a=function(a){return r(t,Object.assign({variant:"caption",tag:"div"},a))};export{a as default};
